import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';

import Sidebar from '../components/admin/Sidebar';
import Topbar from '../components/admin/Topbar';

const drawerWidth = 240;

function AdminLayout() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [desktopOpen, setDesktopOpen] = useState(true);
  const [currentPage, setCurrentPage] = useState('dashboard');

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleDesktopDrawerToggle = () => {
    setDesktopOpen(!desktopOpen);
  };

  return (
    <div className="flex">
      <Topbar
        handleDrawerToggle={handleDrawerToggle}
        handleDesktopDrawerToggle={handleDesktopDrawerToggle}
        desktopOpen={desktopOpen}
      />
      <Sidebar
        mobileOpen={mobileOpen}
        handleDrawerToggle={handleDrawerToggle}
        desktopOpen={desktopOpen}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
      />
      <main
        className="flex-grow p-6 mt-16 w-full sm:w-auto"
        style={{ width: `calc(100% - ${drawerWidth}px)` }}
      >
        <Outlet />
      </main>
    </div>
  );
}

export default AdminLayout;
